import React from 'react';

import Image from '../../../../library/image/image';
import SnowyRoad from '../../../snowy-road/snowy-road';

import './snow-acceleration-chart.scss';

interface SnowAccelerationChartProps {
  bottomOffset?: number;
  value: number;
}

function SnowAccelerationChart(props: SnowAccelerationChartProps) {
  const { bottomOffset = 0, value } = props;

  return (
    <div styleName="container">
      <span style={{ bottom: bottomOffset + 21 }} styleName="value">
        {value?.toFixed(1)} Sec
      </span>
      <span style={{ bottom: bottomOffset + 27 }} styleName="label">
        30mph
      </span>
      <div style={{ bottom: bottomOffset + 8 }} styleName="empty" />
      <div style={{ bottom: bottomOffset + 8 }} styleName="fill" />
      <Image
        alt="Car Image"
        src="https://discounttire.scene7.com/is/image/discounttire/ic_car?fmt=png-alpha"
        style={{ bottom: bottomOffset + 6 }}
        styleName="car-image"
      />

      <SnowyRoad />
    </div>
  );
}

export default SnowAccelerationChart;
